import React, { useState } from 'react'
import addIcon from '../../assets/images/icons/add.svg';
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal, Empty } from "antd";
import backButton from '../../assets/images/back_button_arrow.svg';
import siteIcon from '../../assets/images/icons/site.svg';
import { SearchOutlined } from '@ant-design/icons';

const { Option } = Select;


function resetFormView() { };

const SiteRemoteForm = ({ handlePageViewChange }) => {


    const [searchValue, setSearchValue] = useState('');
    const [filterApply, setFilterApply] = useState({
        publisher: [],
    });

    const options = [
        { value: 'jack1', label: 'Jack 1' },
        { value: 'lucy1', label: 'Lucy 1' },
        { value: 'lucy8', label: 'Lucy 8' },
        { value: 'tom8', label: 'Tom 8' },
        { value: 'jack9', label: 'Jack 9' },
        { value: 'lucy9', label: 'Lucy 9' },
        { value: 'tom9', label: 'Tom 9' },
    ];

    const handleSearch = (e) => {
        setSearchValue(e.target.value.toLowerCase());
    };

    // const onChange = (value) => {
    //     console.log(`Selected: ${value}`);
    // };

    const handleFilterApply = (type, value) => {
        setFilterApply((prev) => {
            const currentPublishers = prev.publisher;
            const isSelected = currentPublishers.includes(value);

            // Toggle selection
            const updatedPublishers = isSelected
                ? currentPublishers.filter((item) => item !== value)
                : [...currentPublishers, value];

            return { ...prev, publisher: updatedPublishers };
        });
    };

    // Filtering options based on search input
    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(searchValue)
    );






    const onChange = (value) => {
        console.log(`selected ${value}`);
    };
    const onSearch = (value) => {
        console.log('search:', value);
    };

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}>
                                <img src={siteIcon} alt="USP" /> Demand
                            </Link>
                        </li>
                        <li className="">Freewheel</li>
                        <li className="">Zone - 221530</li>
                        <li className="primary">Remote Feed</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}
                        />
                        <h1 className="heading">
                            Create Remote Feed
                        </h1>
                    </div>
                </div>
                <div className="container_box--content pt_20">
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Zone</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container border-0 p-0">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value m-0">
                                                <p className='m-0 zone_label_text'>CTV-RTB-Aniview (221530) </p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>General</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Feed Type</label>
                                                <Input className='form_control basic' disabled autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Name *</label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                        <span className="form_label">
                                                            Enabled
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value mb-0">
                                                <label className="form_label">Notes</label>
                                                <Input className='form_control basic form_control_h --80' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>


                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Feed Account</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Override Feed Host *</label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Feed ID *</label>
                                                <Input className='form_control basic ' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Feed SubID </label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Feed Auth </label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Feed Extra * </label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Stats Login/ID * </label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Stats Password/Token * </label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <div className="form_content_block--group mb_0">
                                                            <label className="form_label">Bids' Revshare (%)</label>
                                                            <Input className='form_control basic' value={100} autocomplete="off" />
                                                        </div>
                                                        <span className="error_content"></span>
                                                    </Col>
                                                    <Col span={12}>
                                                        <div className="form_content_block--group mb_0">
                                                            <label className="form_label">Revenue Revshare  (%)</label>
                                                            <Input className='form_control basic' value={100} autocomplete="off" />
                                                            <span className="error_content"></span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Contact </label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Email </label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Web Account URL </label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Web Account Login </label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value mb-0">
                                                <label className="form_label">Web Account Password </label>
                                                <Input className='form_control basic' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Optimization</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <div className="form_content_block--group prefixIconCss_d2">
                                                <label className="form_label">Min eCPM</label>
                                                <Input className='form_control basic' placeholder='0' autocomplete="off" prefix={'$'} />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group prefixIconCss_d2">
                                                <label className="form_label">Max eCPM</label>
                                                <Input className='form_control basic' placeholder='0' autocomplete="off" prefix={'$'} />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                        <Col span={24}>
                                            <div className="form_content_block--group prefixIconCss_d2">
                                                <label className="form_label">Max Bidfloor</label>
                                                <Input className='form_control basic' placeholder='0' autocomplete="off" prefix={'$'} />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group prefixIconCss_d2">
                                                <label className="form_label">Underpay</label>
                                                <Input className='form_control basic' placeholder='0' value={1} autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group prefixIconCss_d2">
                                                <label className="form_label">Expected QPS</label>
                                                <Input className='form_control basic' placeholder='' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>


                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Targeting</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Impression Types</label>
                                                <Input className='form_control basic' autocomplete="off" placeholder='' disabled value='Video' />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Traffic Type * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group">
                                                <label className="form_label">
                                                    Video Player Sizes
                                                </label>
                                                <Radio.Group className="form_checkbox equal_space">
                                                    <Checkbox className="checkbox_btn" value="Website">
                                                        Small
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn" value="Inapp">
                                                        Medium
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn" value="CTV">
                                                        Large
                                                    </Checkbox>
                                                </Radio.Group>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Interstitial Match </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Locations </label>
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={20}>
                                                    <Col span={7}>
                                                        <label className="form_label">Referrer List Mode * </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17}>
                                                        <label className="form_label">Referrer List * </label>

                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                showSearch={false}
                                                                placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={20}>
                                                    <Col span={7}>
                                                        <label className="form_label">App List Mode * </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17}>
                                                        <label className="form_label">App List * </label>

                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                showSearch={false}
                                                                placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={20}>
                                                    <Col span={7}>
                                                        <label className="form_label">Device Ifa List Mode </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17} className='disabled_ant_select_d2'>
                                                        <label className="form_label">Device Ifa Lists </label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                disabled={true}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                showSearch={false}
                                                                // placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Device Ifa Retargeting Lists </label>
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={20}>
                                                    <Col span={7}>
                                                        <label className="form_label">Publisher Id List Mode </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17} className='disabled_ant_select_d2'>
                                                        <label className="form_label">Publisher Id Lists </label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                disabled={true}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                showSearch={false}
                                                                // placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={20}>
                                                    <Col span={7}>
                                                        <label className="form_label">Site Id List Mode </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17} className='disabled_ant_select_d2'>
                                                        <label className="form_label">Site Id Lists </label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                disabled={true}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                showSearch={false}
                                                                // placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={20}>
                                                    <Col span={7}>
                                                        <label className="form_label">App Id List Mode </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17} className='disabled_ant_select_d2'>
                                                        <label className="form_label">App Id Lists </label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                disabled={true}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                showSearch={false}
                                                                // placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={20}>
                                                    <Col span={7}>
                                                        <label className="form_label">IP List Mode </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17} className='disabled_ant_select_d2'>
                                                        <label className="form_label">IP Lists </label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                disabled={true}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                showSearch={false}
                                                                // placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={20}>
                                                    <Col span={7}>
                                                        <label className="form_label">Tag Id List Mode </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17} className='disabled_ant_select_d2'>
                                                        <label className="form_label">Tag Id Lists </label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                disabled={true}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                showSearch={false}
                                                                // placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">OMID Partners List Mode </label>
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        // disabled={true}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">OMID Partners</label>
                                                <Input className='form_control basic form_control_h --80' disabled autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Display Managers List Mode </label>
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        // disabled={true}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value mb-0">
                                                <label className="form_label">Display Managers</label>
                                                <Input className='form_control basic form_control_h --80' disabled autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Devices</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <label className="form_label">Operating Systems </label>
                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                            <Select
                                                id="adcodeSelect"
                                                value={filterApply.publisher}
                                                // disabled={true}
                                                popupClassName='diff_select_d2 --full'
                                                // open={true}
                                                showSearch={false}
                                                placeholder='- Select -'
                                                className="form_select basic"
                                                mode='multiple'
                                                maxTagCount='responsive'
                                                dropdownRender={menu => (
                                                    <>
                                                        <div className="custom_inside_searchbar_d2">
                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                        </div>
                                                        {menu}
                                                    </>
                                                )}
                                            >
                                                {filteredOptions.map(option => (
                                                    <Option key={option.value} value={option.value}>
                                                        <div
                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                        >
                                                            <Checkbox
                                                                checked={filterApply.publisher.includes(option.value)}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                {option.label}
                                                            </Checkbox>
                                                        </div>
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <label className="form_label">Browsers </label>
                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                            <Select
                                                id="adcodeSelect"
                                                value={filterApply.publisher}
                                                // disabled={true}
                                                popupClassName='diff_select_d2 --full'
                                                // open={true}
                                                showSearch={false}
                                                placeholder='- Select -'
                                                className="form_select basic"
                                                mode='multiple'
                                                maxTagCount='responsive'
                                                dropdownRender={menu => (
                                                    <>
                                                        <div className="custom_inside_searchbar_d2">
                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                        </div>
                                                        {menu}
                                                    </>
                                                )}
                                            >
                                                {filteredOptions.map(option => (
                                                    <Option key={option.value} value={option.value}>
                                                        <div
                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                        >
                                                            <Checkbox
                                                                checked={filterApply.publisher.includes(option.value)}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                {option.label}
                                                            </Checkbox>
                                                        </div>
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                <span className="form_label">
                                                    Auto-include new browser versions
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <label className="form_label">Device Types * </label>
                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                            <Select
                                                id="adcodeSelect"
                                                value={filterApply.publisher}
                                                // disabled={true}
                                                popupClassName='diff_select_d2 --full'
                                                // open={true}
                                                showSearch={false}
                                                placeholder='- Select -'
                                                className="form_select basic"
                                                mode='multiple'
                                                maxTagCount='responsive'
                                                dropdownRender={menu => (
                                                    <>
                                                        <div className="custom_inside_searchbar_d2">
                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                        </div>
                                                        {menu}
                                                    </>
                                                )}
                                            >
                                                {filteredOptions.map(option => (
                                                    <Option key={option.value} value={option.value}>
                                                        <div
                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                        >
                                                            <Checkbox
                                                                checked={filterApply.publisher.includes(option.value)}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                {option.label}
                                                            </Checkbox>
                                                        </div>
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <label className="form_label">Device Brand Models </label>
                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                            <Select
                                                id="adcodeSelect"
                                                value={filterApply.publisher}
                                                // disabled={true}
                                                popupClassName='diff_select_d2 --full'
                                                // open={true}
                                                showSearch={false}
                                                placeholder='- Select -'
                                                className="form_select basic"
                                                mode='multiple'
                                                maxTagCount='responsive'
                                                dropdownRender={menu => (
                                                    <>
                                                        <div className="custom_inside_searchbar_d2">
                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                        </div>
                                                        {menu}
                                                    </>
                                                )}
                                            >
                                                {filteredOptions.map(option => (
                                                    <Option key={option.value} value={option.value}>
                                                        <div
                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                        >
                                                            <Checkbox
                                                                checked={filterApply.publisher.includes(option.value)}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                {option.label}
                                                            </Checkbox>
                                                        </div>
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <label className="form_label">Connection Type </label>
                                        <Select
                                            showSearch
                                            className='form_select basic no_search'
                                            placeholder="-Select-"
                                            optionFilterProp="label"
                                            onChange={onChange}
                                            onSearch={onSearch}
                                            options={[
                                                {
                                                    value: 'jack',
                                                    label: 'Jack',
                                                },
                                                {
                                                    value: 'lucy',
                                                    label: 'Lucy',
                                                },
                                                {
                                                    value: 'tom',
                                                    label: 'Tom',
                                                },
                                            ]}
                                        />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group  hide_caret_after_select_value mb-0">
                                        <label className="form_label">Carriers </label>
                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                            <Select
                                                id="adcodeSelect"
                                                value={filterApply.publisher}
                                                // disabled={true}
                                                popupClassName='diff_select_d2 --full'
                                                // open={true}
                                                showSearch={false}
                                                placeholder='- Select -'
                                                className="form_select basic"
                                                mode='multiple'
                                                maxTagCount='responsive'
                                                dropdownRender={menu => (
                                                    <>
                                                        <div className="custom_inside_searchbar_d2">
                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                        </div>
                                                        {menu}
                                                    </>
                                                )}
                                            >
                                                {filteredOptions.map(option => (
                                                    <Option key={option.value} value={option.value}>
                                                        <div
                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                        >
                                                            <Checkbox
                                                                checked={filterApply.publisher.includes(option.value)}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                {option.label}
                                                            </Checkbox>
                                                        </div>
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                        <span className="error_content"> </span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Seller</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <label className="form_label">Send Seller Data * </label>
                                        <Select
                                            showSearch
                                            className='form_select basic no_search'
                                            placeholder="-Select-"
                                            optionFilterProp="label"
                                            onChange={onChange}
                                            onSearch={onSearch}
                                            options={[
                                                {
                                                    value: 'jack',
                                                    label: 'Jack',
                                                },
                                                {
                                                    value: 'lucy',
                                                    label: 'Lucy',
                                                },
                                                {
                                                    value: 'tom',
                                                    label: 'Tom',
                                                },
                                            ]}
                                        />
                                        <span className="error_content"> </span>
                                    </div>
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb_0">
                                                <label className="form_label">Min Supply Chain Length</label>
                                                <Input className='form_control basic' value={1} autocomplete="off" />
                                            </div>
                                            <span className="error_content"></span>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb_0">
                                                <label className="form_label">Max Supply Chain Length</label>
                                                <Input className='form_control basic' value={2} autocomplete="off" />
                                                <span className="error_content"></span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Filters</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="Non_Empty_Referrer">
                                                <span className="form_label">
                                                    Non-Empty Referrer
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="Referrer_Match">
                                                <span className="form_label">
                                                    Referrer Match
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="Non_Empty_Application">
                                                <span className="form_label">
                                                    Non-Empty Application
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="App_Bundle_Match">
                                                <span className="form_label">
                                                    App Bundle Match
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="IP_Match">
                                                <span className="form_label">
                                                    IP Match
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="Geo_Location_Match">
                                                <span className="form_label">
                                                    Geo Location Match
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="Valid_User_Agent">
                                                <span className="form_label">
                                                    Valid User-Agent
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="User_Agent_Match">
                                                <span className="form_label">
                                                    User-Agent Match
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="Non_Repeated_Impressions">
                                                <span className="form_label">
                                                    Non-Repeated Impressions
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group mb-0">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="Discounted_Impressions">
                                                <span className="form_label">
                                                    Discounted Impressions
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Ad Quality</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container ">
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <label className="form_label">Seat List Mode </label>
                                        <Select
                                            showSearch
                                            className='form_select basic no_search'
                                            placeholder="-Select-"
                                            optionFilterProp="label"
                                            onChange={onChange}
                                            onSearch={onSearch}
                                            options={[
                                                {
                                                    value: 'jack',
                                                    label: 'Jack',
                                                },
                                                {
                                                    value: 'lucy',
                                                    label: 'Lucy',
                                                },
                                                {
                                                    value: 'tom',
                                                    label: 'Tom',
                                                },
                                            ]}
                                        />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group hide_caret_after_select_value">
                                        <label className="form_label">Seats</label>
                                        <Input className='form_control basic form_control_h --80' disabled autocomplete="off" />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <label className="form_label">Creative Id List Mode </label>
                                        <Select
                                            showSearch
                                            className='form_select basic no_search'
                                            placeholder="-Select-"
                                            optionFilterProp="label"
                                            onChange={onChange}
                                            onSearch={onSearch}
                                            options={[
                                                {
                                                    value: 'jack',
                                                    label: 'Jack',
                                                },
                                                {
                                                    value: 'lucy',
                                                    label: 'Lucy',
                                                },
                                                {
                                                    value: 'tom',
                                                    label: 'Tom',
                                                },
                                            ]}
                                        />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group hide_caret_after_select_value">
                                        <label className="form_label">Creative Ids</label>
                                        <Input className='form_control basic form_control_h --80' disabled autocomplete="off" />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <Row gutter={20}>
                                            <Col span={7}>
                                                <label className="form_label">Campaign Id List Mode </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </Col>
                                            <Col span={17} className='disabled_ant_select_d2'>
                                                <label className="form_label">Campaign Id Lists </label>
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        disabled={true}
                                                        popupClassName='diff_select_d2 --half'
                                                        // open={true}
                                                        showSearch={false}
                                                        // placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                                <span className="error_content"> </span>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                <span className="form_label">
                                                    Creative Sampling
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <label className="form_label">Creative Approval Mode </label>
                                        <Select
                                            showSearch
                                            className='form_select basic no_search'
                                            placeholder="-Select-"
                                            optionFilterProp="label"
                                            onChange={onChange}
                                            onSearch={onSearch}
                                            options={[
                                                {
                                                    value: 'jack',
                                                    label: 'Jack',
                                                },
                                                {
                                                    value: 'lucy',
                                                    label: 'Lucy',
                                                },
                                                {
                                                    value: 'tom',
                                                    label: 'Tom',
                                                },
                                            ]}
                                        />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                        <label className="form_label">Ad Quality System </label>
                                        <Select
                                            showSearch
                                            className='form_select basic no_search'
                                            placeholder="-Select-"
                                            optionFilterProp="label"
                                            onChange={onChange}
                                            onSearch={onSearch}
                                            options={[
                                                {
                                                    value: 'jack',
                                                    label: 'Jack',
                                                },
                                                {
                                                    value: 'lucy',
                                                    label: 'Lucy',
                                                },
                                                {
                                                    value: 'tom',
                                                    label: 'Tom',
                                                },
                                            ]}
                                        />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group hide_caret_after_select_value">
                                        <label className="form_label">Number of Daily Scans </label>
                                        <Input className='form_control basic' autocomplete="off" />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group mb-0">
                                        <div className="primary_checkbox">
                                            <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                <span className="form_label">
                                                    Notify Provider via E-mail
                                                </span>
                                            </Checkbox>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Limits</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container mb_0">
                                    <div className="form_content_block--group hide_caret_after_select_value">
                                        <label className="form_label">Average Requests per Day </label>
                                        <Input className='form_control basic' autocomplete="off" />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group hide_caret_after_select_value">
                                        <label className="form_label">Average Impressions per Day </label>
                                        <Input className='form_control basic' autocomplete="off" />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group hide_caret_after_select_value">
                                        <label className="form_label">Impressions per IP </label>
                                        <Input className='form_control basic' autocomplete="off" />
                                        <span className="error_content"> </span>
                                    </div>
                                    <div className="form_content_block--group hide_caret_after_select_value mb-0">
                                        <label className="form_label">Clicks per IP </label>
                                        <Input className='form_control basic' autocomplete="off" />
                                        <span className="error_content"> </span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        <button className="w_120_d2 btn btn_white_outline w_fit_content"> Discard </button>
                        <button className="w_120_d2 btn btn_primary w_fit_content">Create Zone</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SiteRemoteForm
